//scroll variable to track window's scroll
var lastScrollTop = 0;
var mobileW = 0;

//vanilla variables for resizing
var w = window,
  d = document,
  e = d.documentElement,
  g = d.getElementsByTagName("body")[0],
  windowWidth = w.innerWidth || e.clientWidth || g.clientWidth,
  windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

//header image to be window height on homepage
if (document.getElementsByClassName("img-slide").length > 0) {
  let headerImages = document.getElementsByClassName("img-slide");
  let headerImagesLength = headerImages.length;
  for (let i = 0; i < headerImagesLength; i++) {
    headerImages[i].style.height = windowHeight + 10 + "px";
  }
}
resizeWindow();

// Func = limiting Scope for this file
(function () {
  window.onload = function () {
    resizeWindow();
    scrollW();
  };

  window.addEventListener("scroll", function () {
    scrollW();
  });
  window.addEventListener("resize", function () {
    resizeWindow();
  });

  //scroll down click
  if (document.getElementsByClassName("top-content__down").length > 0) {
    document
      .getElementsByClassName("top-content__down")[0]
      .addEventListener("click", function () {
        animateTo("intro");
      });
  }

  //div effect for Btn
  $(".btn").filter(function (i, item) {
    let lineText = $(item).text();
    $(item).html(`
			<div class="btn-efect">
				<span data-hover="${lineText}">${lineText}</span>
			</div>
			`);
  });
  $("button.btn").filter(function (i, item) {
    let lineText = $(item).text();
    $(item).html(`
			<div class="btn-efect">
				<span data-hover="${lineText}">${lineText}</span>
			</div>
			`);
  });
  $("button.signup-btn").filter(function (i, item) {
    let lineText = $(item).text();
    $(item).html(`
			<div class="btn-efect">
				<span data-hover="${lineText}">${lineText}</span>
			</div>
			`);
  });

  //mobile burger menu
  document.getElementById("burgerMenu").addEventListener("click", function () {
    if (!this.classList.contains("open")) {
      this.parentElement.classList.add("open");
      this.classList.add("open");
      document.querySelector(".privary-navigation").classList.add("open");
      // document.getElementById('menu-js').classList.add('active');
      document.getElementById("header").classList.add("active");
      document.getElementById("nav-menu").innerHTML = "CLOSE";
    } else {
      this.classList.remove("open");
      this.parentElement.classList.remove("open");
      document.querySelector(".privary-navigation").classList.remove("open");
      // document.getElementById('menu-js').classList.remove('active');
      document.getElementById("header").classList.remove("active");
      document.getElementById("nav-menu").innerHTML = "MENU";
    }
  });

  $("input[type=date]").on("input", function () {
    if ($(this).val().length > 0) {
      $(this).addClass("full");
    } else {
      $(this).removeClass("full");
    }
  });

  //Tabs filter function
  let links = document.querySelectorAll('.tab-js');
	let contents = document.querySelectorAll('.tab-content-js');  
    

	if(links.length != 0 && contents.length != 0){
		links[0].classList.add('active');
		contents[0].classList.add('active');
	}

	links.forEach((link) => {
		link.addEventListener('click', () => {
			links.forEach((allLinks) => {
				allLinks.classList.remove('active');
			});
			link.classList.add('active');
			contents.forEach((content) => {
				let linkTag = link.getAttribute('data-tag');
				let contentTag = content.getAttribute('data-tag');
				content.classList.remove('active');
				if (linkTag === contentTag) {
					content.classList.add('active');
				}
			});
		});
	});

//Tabs filter function for select

let select = document.querySelector('select');

if (links.length !== 0 && contents.length !== 0) {
  links[0].classList.add('active');
  contents[0].classList.add('active');
}

function handleSelectChange() {
  let selectedOption = select.options[select.selectedIndex];
  let selectedTag = selectedOption.getAttribute('data-tag');
  
  links.forEach((link) => {
    let linkTag = link.getAttribute('data-tag');    
    link.classList.remove('active');
    if (linkTag === selectedTag) {
      link.classList.add('active');
    }
  });

  contents.forEach((content) => {
    let contentTag = content.getAttribute('data-tag');
    
    content.classList.remove('active');
    if (contentTag === selectedTag) {
      content.classList.add('active');
    }
  });
}

links.forEach((link) => {
  link.addEventListener('click', () => {
    links.forEach((allLinks) => {
      allLinks.classList.remove('active');
    });
    link.classList.add('active');
    
    let linkTag = link.getAttribute('data-tag');
    
    select.querySelectorAll('option').forEach((option) => {
      let optionTag = option.getAttribute('data-tag');
      
      if (optionTag === linkTag) {
        option.selected = true;
      } else {
        option.selected = false;
      }
    });
    
    contents.forEach((content) => {
      let contentTag = content.getAttribute('data-tag');      
      content.classList.remove('active');
      if (linkTag === contentTag) {
        content.classList.add('active');
      }
    });
  });
});

if (typeof(select) != 'undefined' && select != null) {
  select.addEventListener('change', handleSelectChange);

}
})();

function scrollW() {
  //check scroll down or up for header styles
  let st = window.pageYOffset || document.documentElement.scrollTop;

  if (st > 80) {
    if (st > lastScrollTop) {
      // downscroll code
      if (!document.getElementById("header").classList.contains("down")) {
        document.getElementById("header").classList.add("down");
        document.getElementById("header").classList.remove("up");
        //document.getElementById('header').classList.add('internal')
      }
    } else {
      //upscroll code
      if (!document.getElementById("header").classList.contains("up")) {
        document.getElementById("header").classList.add("up");
        document.getElementById("header").classList.remove("down");
        //document.getElementById('header').classList.remove('internal');
      }
    }
  } else {
    // if(document.getElementById('home') && document.getElementById('header').classList.contains('down')){
    // 	document.getElementById('header').classList.remove('down');
    // 	if(windowWidth > 600){
    // 		logoUrl = site_url + 'assets/svg/logo.svg';
    // 		document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
    // 	}
    // }

    if (
      document.getElementById("header").classList.contains("up") ||
      document.getElementById("header").classList.contains("down")
    ) {
      document.getElementById("header").classList.remove("up");
      document.getElementById("header").classList.remove("down");
      // if(document.getElementById('home') && windowWidth > 600) {
      // 	logoUrl = site_url + 'assets/svg/logo.svg';
      // 	document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
      // }
    }
    // if(!document.getElementById('home') && !document.getElementById('header').classList.contains('internal')){

    // 	document.getElementById('header').classList.add('internal');
    // }
  }

  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow() {
  //calculate a new window size
  windowWidth = w.innerWidth || e.clientWidth || g.clientWidth;
  windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

  //header image to be window height on homepage
  if (document.getElementsByClassName("img-slide").length > 0) {
    let headerImages = document.getElementsByClassName("img-slide");
    let headerImagesLength = headerImages.length;
    for (let i = 0; i < headerImagesLength; i++) {
      headerImages[i].style.height = windowHeight + 10 + "px";
    }
  }
}

//animation of scroll vanilla JS
function animateTo(target) {
  var gotoTarget = offset(document.getElementById(target)).top - 100;
  var from = window.pageYOffset;
  var to = gotoTarget;
  var duration = 1300;
  var start = new Date().getTime();

  //time interval
  var timer = setInterval(function () {
    var time = new Date().getTime() - start;

    if (from <= to) {
      var yH = easeInOutQuart(time, from, to - from, duration);
    } else {
      var yH = easeInOutQuart(time, from, -(from - to), duration);
    }
    window.scrollTo(0, yH);
    if (time >= duration) clearInterval(timer);
  }, 600 / 60);

  window.scrollTo(0, from);
}

//ease movement
function easeInOutQuart(t, b, c, d) {
  if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
  return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
  var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

// ============================
//    EVENTS FILTER
// ============================
function filterEvents(value) {
  let events = document.querySelectorAll(".filter-column__item");
  // let counter = 0
  events.forEach((element) => {
    if (element.classList.contains(value) || value === "blank") {
      element.classList.remove("hidden");
      element.classList.remove("animate-fade");
    } else {
      // counter++;
      element.classList.add("hidden");
    }
  });
  // if(counter === events.length) {
  // 	events.forEach(el => {
  // 		el.classList.remove("hidden")
  // 	});
  // }
}
// Conditional to capture each element of the filter options list DESKTOP
if (document.querySelectorAll(".filter-column__list--item")) {
  let items = document.querySelectorAll(".filter-column__list--item");
  for (let i = 0; i < items.length; i++) {
    items[i].addEventListener("click", () => {
      let newValue = items[i].textContent.toLowerCase();
      filterEvents(newValue);
    });
  }
}

// Conditional to capture each element of the filter options list MOBILE
if (document.querySelector(".filter-column__list--mobile")) {
  console.log("Existe en mobile");
  let myChoice = document.querySelector(".filter-column__list--mobile")
  myChoice.addEventListener("change", () => {
    let value = myChoice.value
    filterEvents(value)
  })
}